import React from 'react';
import { Form, Button, Icon, Message, Divider } from 'semantic-ui-react'
import _find from 'lodash/find';

const DetalleNivel1 = props => {
  return (
    <option value={props.elemento.path}>{props.elemento.message}</option>
  )
};

const Lista = ({list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, i) => <DetalleNivel1 elemento={elemento} key={i} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="bdConn" id="bdConn" onChange={(ev)=>handleChange(ev)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

export default ({styles, handleSubmit, handleChange, args, errors}) => {
  const fechaHoy = new Date()
  const hora = fechaHoy.getHours()
  let saludo = "!! Buenas noches !!"
  if(hora>=6&&hora<12){
      saludo = "!! Buenos días !!"
  }
  if(hora>=12&&hora<18){
      saludo = "!! Buenas tardes !!"
  }
  // console.log(errors)

  let list = errors.filter(elemento => elemento.path!=="varias")
// console.log(list)
  return (
    <div style={styles.box}>
      <div>
        <h1 style={{color: 'white', fontWeight: 'bold'}}>{saludo}</h1>
        <Divider inverted />
        <p style={{color: 'white'}}>Bienvenido a</p>
        <img src="images/foroptic.png" alt="Logo"/>

        <Divider inverted />
        <br></br>

        <Form onSubmit={(ev)=>handleSubmit(ev, args, errors)}>
          <Form.Field>
            <label style={styles.label}>Correo electrónico</label>
            <Form.Input name="email" onChange={handleChange} placeholder='Correo electrónico' icon={!errors.length?null: _find(errors, {path:'email'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
          </Form.Field>
          <Form.Field>
            <label style={styles.label}>Clave de acceso</label>
            <Form.Input autoComplete="off" name="claveDeAcceso" onChange={handleChange}  type='password' placeholder='Clave de acceso' icon={!errors.length?null: _find(errors, {path:'Clave de acceso'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
          </Form.Field>

          {(errors.length>0 && errors[0].path==="varias") &&
            <Form.Field>
              <label style={styles.label}>Base de datos</label>
              <Lista list={list} handleChange={handleChange}/>
            </Form.Field>
          }

          <Divider inverted />

          {/* <Divider/> */}

          <Button style={styles.confirmar} type='submit' fluid>
            Ingresar
          </Button>
          <br></br>

          {/* <Button type='submit' primary fluid>Ingresar</Button> */}

          {(errors.length>0 && errors[0].path!=="varias") &&
            <Message negative header="Los siguientes errores:"
            list={errors.map(error=>`${error.path}: ${error.message}`)} />
          }

      </Form>
    </div>
  </div>)
}
